interface SelectAllBannerProps {
  mode: 'offer' | 'all';
  /** Rows selected on the current page (offer mode). */
  pageCount: number;
  /** Total contacts matching the current filter. */
  total: number;
  onSelectAll: () => void;
  onClear: () => void;
}

/**
 * Gmail-style banner under the bulk-action bar: when a full page is selected,
 * offers extending the selection to every contact matching the current filter
 * ("set selection"); in set mode, confirms the scope and offers clearing it.
 */
export function SelectAllBanner({ mode, pageCount, total, onSelectAll, onClear }: SelectAllBannerProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: '7px 12px',
        background: 'var(--brand-soft)',
        borderLeft: '1px solid var(--border)',
        borderRight: '1px solid var(--border)',
        fontSize: 12.5,
        color: 'var(--text-2)',
      }}
    >
      {mode === 'offer' ? (
        <>
          <span>
            All <strong>{pageCount.toLocaleString()}</strong> contacts on this page are selected.
          </span>
          <button type="button" className="link-button" style={LINK_STYLE} onClick={onSelectAll}>
            Select all {total.toLocaleString()} contacts matching the current filter
          </button>
        </>
      ) : (
        <>
          <span>
            All <strong>{total.toLocaleString()}</strong> contacts matching the current filter are
            selected.
          </span>
          <button type="button" className="link-button" style={LINK_STYLE} onClick={onClear}>
            Clear selection
          </button>
        </>
      )}
    </div>
  );
}

const LINK_STYLE: React.CSSProperties = {
  border: 'none',
  background: 'none',
  padding: 0,
  font: 'inherit',
  fontWeight: 600,
  color: 'var(--brand)',
  cursor: 'pointer',
  textDecoration: 'underline',
  textUnderlineOffset: 2,
};
